var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167042",
    "data-name": "Group 167042",
    transform: "translate(-44 -453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_18_1",
    "data-name": "Component 18 \\u2013 1",
    transform: "translate(44 453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83179",
    "data-name": "Path 83179",
    d: "M23,0C40.851,0,46,5.149,46,23S40.851,46,23,46,0,40.851,0,23,5.149,0,23,0Z",
    fill: "#f2f3f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_167018",
    "data-name": "Group 167018",
    transform: "translate(11.61 23.059) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    x2: 16,
    transform: "translate(0.096 7.631)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    x2: 16,
    transform: "translate(8.096 0.012) rotate(90)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBoxIcon);
export default __webpack_public_path__ + "static/media/closeBox_icon.74ec0498e72c7f818481d64cb4a43bf8.svg";
export { ForwardRef as ReactComponent };